/**
 * Size guide PDP drawer (`iam-aside#SizeGuideDrawer`).
 *
 * Opens via the in-page trigger: a control with `data-aside-target="SizeGuideDrawer"`
 * (see `size-guide.liquid`), which the shared `iam-aside` component wires on click.
 *
 * To open manually while debugging (e.g. from DevTools console):
 *   document.getElementById('SizeGuideDrawer')?.openAside();
 */
import 'snippets/_containers/aside/aside';
import './_size-guide.scss';